import React, { FC } from 'react';
import {
  Button,
  FormGroup,
  Input,
  Label,
  PopoverBody,
  PopoverHeader,
  UncontrolledPopover,
} from 'reactstrap';
import { UserSearchFilterContext } from '../../../../shared/user/search';
import { MaterialIcon } from '../../../components';
import { useTranslation } from '../../../translations';

interface UserContextProp {
  readonly context: UserSearchFilterContext;
  readonly setContext: (context: UserSearchFilterContext) => void;
}

export const SearchUserFilters: FC<UserContextProp> = ({ context, setContext }) => {
  const { ts } = useTranslation();

  return (
    <Button id="openSettingsPopover">
      <MaterialIcon name="tune" type="white" />
      <UncontrolledPopover placement="bottom" target="openSettingsPopover" trigger="legacy">
        <PopoverHeader>{ts('attendee_search_filter_modal_title')}</PopoverHeader>
        <PopoverBody>
          <UpdateUserSearchFilters context={context} setContext={setContext} />
        </PopoverBody>
      </UncontrolledPopover>
    </Button>
  );
};

const UpdateUserSearchFilters: FC<UserContextProp> = ({ context, setContext }) => {
  const { ts } = useTranslation();

  return (
    <>
      <FormGroup switch>
        <Input
          className="form-switch-input"
          defaultChecked={context.printedUsers}
          id="only-printed-users"
          name="badge-print-only"
          onChange={(el) => {
            setContext({ ...context, printedUsers: el.target.checked });
          }}
          type="switch"
        />
        <Label check>{ts('attendee_search_filter_only_printed')}</Label>
      </FormGroup>
      <FormGroup switch>
        <Input
          className="form-switch-input"
          defaultChecked={context.paidUsers}
          id="only-paid-users"
          name="only-paid-users"
          onChange={(el) => {
            setContext({ ...context, paidUsers: el.target.checked });
          }}
          type="switch"
        />
        <Label check>{ts('attendee_search_filter_only_paid')}</Label>
      </FormGroup>
      <FormGroup switch>
        <Input
          className="form-switch-input"
          defaultChecked={context.dealers}
          id="only-dealers"
          name="only-dealers"
          onChange={(el) => {
            setContext({ ...context, dealers: el.target.checked });
          }}
          type="switch"
        />
        <Label check>{ts('attendee_search_filter_only_dealers')}</Label>
      </FormGroup>
      <FormGroup switch>
        <Input
          className="form-switch-input"
          defaultChecked={context.volunteers}
          id="only-volunteers"
          name="only-volunteers"
          onChange={(el) => {
            setContext({ ...context, volunteers: el.target.checked });
          }}
          type="switch"
        />
        <Label check>{ts('attendee_search_filter_only_volunteers')}</Label>
      </FormGroup>
      <FormGroup switch>
        <Input
          className="form-switch-input"
          defaultChecked={context.badgeName}
          id="include-badge-name"
          name="include-badge-name"
          onChange={(el) => {
            setContext({ ...context, badgeName: el.target.checked });
          }}
          type="switch"
        />
        <Label>{ts('attendee_search_search_badge_name')}</Label>
      </FormGroup>
    </>
  );
};
